import "@mdi/font/css/materialdesignicons.min.css";
import "@/theme/mdi.scss";
import "font-awesome/css/font-awesome.css";

import IconComponent from "./icon.vue";

export { IconComponent };

export const Icon = {
	install(Vue:any, options:any){
		Vue.component("icon", IconComponent);
	}
};